import { SimpleModal, BackdropLoader } from '@livable/saas-react-components';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
// import { useStore } from 'src/stores';
import { observer } from 'mobx-react-lite';
import { Button, Typography } from '@mui/material';
import DOMPurify from 'dompurify';
export const SimpleConfirmationModal = observer(_ref => {
  let headerText = _ref.headerText,
    subTitleText = _ref.subTitleText,
    bodyText = _ref.bodyText,
    bodyComponent = _ref.bodyComponent,
    customTrigger = _ref.customTrigger,
    isLoading = _ref.isLoading,
    externalIsOpen = _ref.externalIsOpen,
    callBack = _ref.callBack,
    objectToPassOver = _ref.objectToPassOver,
    noSubmitButton = _ref.noSubmitButton,
    customSubmitButtonName = _ref.customSubmitButtonName;
  const classes = useStyles();
  // const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SimpleModal, {
    isOpen: externalIsOpen,
    title: headerText,
    subTitle: subTitleText,
    noFooter: true,
    noPadding: true,
    trigger: customTrigger,
    noCloseButton: true
  }, !!bodyComponent ? bodyComponent : /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.modalContent)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body3",
    component: "div"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.textContent
  }, /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: DOMPurify.sanitize(bodyText)
    }
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.modalFooter
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "text",
    onClick: () => callBack({
      action: 'cancel',
      objectToPassOver
    }),
    'custom-attribute': '367-SimpleConformationModal'
  }, t('buttons.cancel')), !noSubmitButton && /*#__PURE__*/React.createElement(Button, {
    onClick: () => callBack({
      action: 'submit',
      objectToPassOver
    }),
    variant: "priority",
    type: "submit",
    'custom-attribute': '368-SimpleConformationModal'
  }, customSubmitButtonName !== null && customSubmitButtonName !== void 0 ? customSubmitButtonName : t('buttons.submit'))), /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }));
});